import {useState, useEffect} from 'react';

import {getRating} from "src/services/rating/get-api";

// ----------------------------------------------------------------------

export default function useUserRatingDataForRecipe(recipeId, onChangeCallback) {
  const [rating, setRating] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const ratingData = await getRating(recipeId);
      setRating(ratingData)
      if (onChangeCallback) {
        onChangeCallback(ratingData);
      }
    }

    fetchData();
  }, [recipeId, onChangeCallback]);

  return {
    rating
  };
}
